import React from "react";
import withLayout from "../../../components/desktop/layout/component";
import ErrorHandler from "../../../components/shared/with-error-handler";
import withReducer from "../../../components/shared/with-reducer";
import injectable from "./injectable";
import GooglemapScript from "../../../components/shared/googlemap-script";
import CityPreDeliveryInspection from "../../../components/desktop/city-pre-delivery-inspection";

const CityPreDeliveryInspectionContainer = () => {
    return (
        <ErrorHandler>
            <GooglemapScript />
            <CityPreDeliveryInspection/>
        </ErrorHandler>
    );
};

export default withReducer(injectable)(
    () => ({}),
    (dispatch) => ({ dispatch })
)(withLayout(CityPreDeliveryInspectionContainer));
